/**
 * The workouts family's public surface: values first, then types.
 *
 * A host mounts `CworkoutcardSet` for the compact tier, `CworkoutcardDetail`
 * for the detail tier, and `CworkoutcardPlan` for the generated-plan answer.
 * Everything else — the row, the rail card, the three card compositions, the
 * demonstration frame — is internal, because a composition chosen from outside
 * the family is how families re-diverge.
 */
export { Cworkoutcard } from "./Cworkoutcard";
export { CworkoutcardSet } from "./CworkoutcardSet";
export { CworkoutcardDetail } from "./CworkoutcardDetail";
export { CworkoutcardPlan } from "./CworkoutcardPlan";

export {
  C_WORKOUT_ASSET_PROBE,
  C_WORKOUT_CARD_VARIANTS,
  C_WORKOUT_CARD_VARIANT_GROUP,
  C_WORKOUT_MOVE_READINGS,
  C_WORKOUT_MOVE_READING_GROUP,
  C_WORKOUT_POSTER_INTRINSIC_HEIGHT,
  C_WORKOUT_POSTER_INTRINSIC_WIDTH,
  DEFAULT_C_WORKOUT_CARD_VARIANT,
  DEFAULT_C_WORKOUT_MOVE_READING,
} from "./cworkoutcard.constants";

export {
  cworkoutcardKey,
  cworkoutcardOrientation,
  cworkoutcardShoot,
  cworkoutcardVendorWords,
  cworkoutcardVideoState,
} from "./cworkoutcard.model";

export {
  CworkoutcardMoveReading,
  CworkoutcardOrientation,
  CworkoutcardPhase,
  CworkoutcardShoot,
  CworkoutcardVariant,
  CworkoutcardVideoState,
} from "./cworkoutcard.types";

export type {
  CworkoutcardClip,
  CworkoutcardData,
  CworkoutcardDetailProps,
  CworkoutcardMedia,
  CworkoutcardPlanData,
  CworkoutcardPlanSlot,
  CworkoutcardPrescription,
  CworkoutcardProps,
  CworkoutcardRailProps,
  CworkoutcardRowProps,
} from "./cworkoutcard.types";
